import type { Theme } from '@mui/material/styles';

// Compiled from the former SCSS partials (common/_base, organisms/*, pages/*) in the same order.
// Colours come from theme.palette.custom (the former SCSS variables in common/_colors.scss).
export const appStyles = (theme: Theme) => {
  const c = theme.palette.custom;

  return String.raw`

body,
html {
  font-family: "Helvetica Neue", sans-serif;
  margin: 0;
}
body button,
body input,
html button,
html input {
  outline: none;
}
html {
  font-size: 24px;
}
@media all and (min-device-width: 376px) {
  html {
    font-size: 20px;
  }
}
@media all and (min-device-width: 576px) {
  html {
    font-size: 16px;
  }
}
@media all and (min-device-width: 768px) {
  html {
    font-size: 13px;
  }
}
@media all and (min-width: 992px) {
  html {
    font-size: 10px;
  }
}

button,
input,
optgroup,
select,
textarea {
  font-family: sans-serif;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html [type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  padding: 0;
}
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}
::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
a:active,
a:hover {
  outline-width: 0;
}
legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}
@media only screen and (max-width: 599px) {
  svg {
    width: 1rem !important;
    height: 1rem !important;
  }
}
.button {
  width: 100%;
  background-color: ${c.yellow};
  border-radius: 0.75rem;
  margin-top: 1.5rem;
}
.button__text {
  font-size: 2.5rem;
  padding: 1rem 0;
  color: ${c.white};
  font-weight: bold;
}
.card {
  display: flex;
  flex-direction: column;
  background: ${c.greyLight};
  background-color: ${c.white};
  border-radius: 0.5rem;
  box-shadow: 0 0px 6px rgba(0, 0, 0, 0.1);
  margin: 1rem 0;
  min-height: 30rem;
}
.card__content, .card__home-title, .card__username, .card__button {
  display: flex;
  justify-content: center;
}
.card__title, .card__home-title, .card__username {
  font-size: 2.25rem;
}
.card__home-title, .card__title {
  font-weight: bold;
}
.card__home-title, .card__content {
  align-items: center;
}
.card__username {
  color: ${c.ruby};
}
.card__title {
  color: ${c.darkBlack1};
  font-family: "Gothic A1", sans-serif;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.625rem;
}
.card__error {
  display: flex;
  font-size: 1.5rem;
  margin-top: 2rem;
  padding: 1rem;
  justify-content: center;
  color: red;
}
.card__content {
  margin-top: 1rem;
  flex-direction: column;
  padding: 1rem 1rem;
  height: 100%;
}
.card__title {
  display: flex;
  justify-content: center;
  padding: 1rem 0 2rem 0;
  width: 100%;
}
.card__title--invalid {
  font-size: 3.25rem;
  color: ${c.mediumRed};
}
.card__item {
  text-align: center;
  color: ${c.greyDark};
  font-size: 1.5rem;
  padding: 0.5rem 0;
}
.card__home-title {
  border-radius: 0.75rem 0.75rem 0 0;
  height: 6rem;
  color: ${c.darkBlack1};
  border-bottom: 1px solid ${c.grey1};
  font-family: "Gothic A1", sans-serif;
  font-size: 1.375rem;
  font-weight: 700;
  margin-bottom: 0.875rem;
}
.card__username {
  align-self: center;
}
.document-form {
  border-bottom: 0.1rem solid ${c.greyLighter};
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.document-form__doc-type, .document-form__status {
  padding: 0.1rem 0;
}
.document-form__input-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 6rem;
}
.document-form__additional-input-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 6rem;
}
.document-form__uploaded-image {
  border-radius: 1rem;
  margin-right: 1.5rem;
  display: block;
  max-width: 6rem;
  max-height: 6rem;
  width: 5rem;
  height: 5rem;
}
.document-form__button-container {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
.document-form__button-container button {
  width: 42%;
  height: 3.5rem;
  align-items: center;
  border: none;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2509803922);
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  border-radius: 100px;
  letter-spacing: 0.46px;
  font-size: 1.1rem;
  padding: 0.5rem 2rem;
  background-color: ${c.green};
  color: ${c.white};
  font-family: "Open Sans";
}
.document-form__button-container button:hover {
  background-color: ${c.green} !important;
}
.document-form__input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.document-form__doc-type {
  font-family: "Open Sans";
  color: ${c.darkBlack1};
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5rem;
  text-align: left;
}
.document-form__description {
  font-family: "Open Sans";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: left;
}
.document-form__edit-section-div {
  padding-left: 1rem;
  border-bottom: 1px solid ${c.greyLight};
}
.document-form__reference-edit-section {
  display: flex;
  justify-content: space-between;
  font-family: "Open Sans";
  font-size: 1rem;
  font-weight: 600;
}
.document-form__reference-edit-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 17px;
  grid-row-gap: 8px;
  padding-bottom: 2rem;
  font-family: "Open Sans";
  font-size: 0.875rem;
  font-weight: 600;
}
@media (max-width: 480px) {
  .document-form__reference-edit-body {
    grid-template-columns: 1fr;
  }
}
.document-form hr {
  background: ${c.greyLight};
}
.document-form__rectangular-box {
  position: absolute;
  width: 100%;
  height: 38px;
  color: ${c.white};
  background: ${c.ruby};
  border-radius: 30px;
}
.document-form__reference-text {
  margin-left: 5px;
  font-size: 1.8rem;
  margin-top: 5px;
}
.document-form__reference-box {
  margin-top: 50px;
}
.document-form__reference-box-details {
  display: "flex";
  width: "100%";
  margin-bottom: "6px";
}
.document-form__vehicle {
  font-size: 11px;
}
.document-form__upload {
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.document-form__remove-image {
  width: 2rem;
}
.document-form__remove-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 4rem;
  width: 4rem;
  background-color: ${c.green};
}
.document-form__image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
  height: 2.938rem;
  width: 3.75rem;
  background-color: ${c.green};
}
.document-form__input-upload {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
}
.document-form__status--received {
  font-size: 1rem;
  color: ${c.greenLight};
  padding: 5px 0;
}
.document-form__status--none {
  font-size: 1rem;
  font-family: "Open Sans";
  color: ${c.errorRed};
  padding: 5px 0;
}
.document-form__button-additional {
  display: flex;
  justify-content: center;
  padding: 1rem;
}
.document-form__button-additional button {
  width: 21.875rem;
  height: 3.5rem;
  align-items: center;
  border: none;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2509803922);
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  border-radius: 100px;
  letter-spacing: 0.46px;
  font-size: 1.1rem;
  padding: 0.5rem 2rem;
  background-color: ${c.green};
  color: ${c.white};
  font-family: "Open Sans";
}
.document-form__button-additional button:hover {
  background-color: ${c.green} !important;
}
.document-form__upload-documents--header {
  font-family: "Gothic A1", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2rem;
  text-align: left;
  padding-left: 1rem;
  color: ${c.darkBlack1};
}
.document-form__upload-documents--description {
  font-family: Open Sans;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-align: left;
  color: ${c.darkBlack1};
  margin-top: 0px;
}
.document-form__additional-items {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
}
.document-form__additional-items--list {
  border-bottom: 0.1rem solid ${c.greyLighter};
}
.document-form__additional-items--info {
  padding-top: 1rem;
}
.document-form__additional-items--header {
  display: flex;
  align-items: center;
  height: 4rem;
  padding-left: 1rem;
  color: ${c.darkBlack1};
  font-family: "Gothic A1", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5rem;
  border-top: 1px solid ${c.grey2};
  border-bottom: 1px solid ${c.grey2};
}
.document-form__additional-items__dropdowns {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-top: 1rem;
  width: 80%;
}
.document-form__additional-items__dropdowns--select {
  width: 90%;
  margin-bottom: 1.5rem;
  background-color: ${c.grey3};
}
.document-form__additional-items__dropdowns--checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
.document-form__additional-items__dropdowns--input {
  padding: 0 1rem;
  margin-bottom: 1rem;
}
.document-form__additional-items__button {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 0 0 auto;
}
.document-form__card {
  border-radius: 8px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  margin: 0 10px 20px 10px;
  overflow: hidden;
  transition: box-shadow 0.3s ease-in-out;
  background: ${c.white};
}
.document-form__card--checkmark {
  width: 2rem;
  height: 2rem;
}
.document-form__card--header {
  display: flex;
  align-items: center;
  height: 4rem;
  padding: 1rem 1rem;
  color: ${c.darkBlack1};
  font-family: "Gothic A1", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5rem;
  justify-content: space-between;
  cursor: pointer;
}
.document-form__card--header-description {
  margin-left: 0.625rem;
}
.document-form__card--header-additionalDocuments {
  margin-left: 0.5rem;
}
.document-form__card--header-title {
  margin-bottom: 0px;
}
.document-form__card--header-progress {
  font-family: "Open Sans";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: left;
  margin-top: 0;
}
.document-form__card--body {
  border-top: 0.1rem solid ${c.greyLighter};
  padding: 0 16px 16px 16px;
}
@media only screen and (max-width: 991.77px) {
  .document-form__button-container {
    position: sticky;
    background: ${c.white};
    bottom: -8px;
    margin-left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    left: 0;
  }
}
@media all and (min-width: 992px) {
  .document-form__button-container {
    position: sticky;
    background: ${c.white};
    bottom: -8px;
    width: 100%;
  }
}
@media all and (min-width: 992px) {
  .document-form__input-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 30rem;
    height: 6rem;
  }
}
@media only screen and (max-width: 599px) {
  .document-form {
    padding: 0.4rem;
  }
  .document-form__doc-type {
    font-size: 0.6rem;
    line-height: 0.7rem;
    word-break: break-word;
  }
  .document-form__description {
    font-size: 0.5rem;
    line-height: 0.7rem;
  }
  .document-form__upload {
    width: auto;
    min-width: 80px;
    justify-content: center;
  }
  .document-form__input-container, .document-form__additional-input-container {
    height: auto;
    min-height: 4rem;
    align-items: flex-start;
  }
  .document-form__uploaded-image {
    width: 3rem;
    height: 3rem;
    max-width: 3rem;
    max-height: 3rem;
    margin-right: 0.2rem;
  }
  .document-form__image-container {
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    border-radius: 0.75rem;
  }
  .document-form__input-upload {
    width: 0.75rem;
    height: 0.75rem;
  }
  .document-form__remove-image-container {
    width: 1.5rem;
    height: 1.5rem;
  }
  .document-form__remove-image {
    width: 0.75rem;
  }
  .document-form__additional-items--header {
    height: auto;
    min-height: 2rem;
  }
  .document-form__button-container {
    padding: 0 12px;
  }
  .document-form__button-container button {
    width: 50%;
    font-size: 0.6rem;
    height: 2rem;
    padding: 0.5rem 1rem;
  }
  .document-form__button-additional {
    padding: 0.75rem;
  }
  .document-form__button-additional button {
    width: 100%;
    font-size: 0.5rem;
    height: 2rem;
  }
  .document-form__reference-edit-section {
    font-size: 0.6rem;
    flex-direction: row;
    gap: 0.3rem;
    margin-bottom: 0.5rem;
  }
  .document-form__reference-edit-section h3 {
    font-size: 0.6rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .document-form__upload-documents--header {
    font-size: 0.6rem;
    line-height: 0.8rem;
    padding-left: 0.75rem;
  }
  .document-form__upload-documents--description {
    font-size: 0.6rem;
    line-height: 0.7rem;
  }
  .document-form__additional-items {
    flex-direction: column;
    gap: 1rem;
  }
  .document-form__additional-items--header {
    font-size: 0.6rem;
    line-height: 0.8rem;
    padding-left: 0.75rem;
  }
  .document-form__additional-items__dropdowns {
    width: 100%;
    padding-top: 0.5rem;
  }
  .document-form__additional-items__dropdowns--select {
    width: 100%;
  }
  .document-form__additional-items__dropdowns--checkbox {
    font-size: 0.8rem;
  }
  .document-form__card--header {
    padding: 0.1rem 0.3rem;
    height: auto;
    min-height: 2rem;
  }
  .document-form__card--checkmark {
    width: 0.75rem;
    height: 0.75rem;
  }
  .document-form__card--header-title {
    font-size: 0.6rem;
    line-height: 0.7rem;
    word-break: break-word;
  }
  .document-form__card--header-progress {
    font-size: 0.6rem;
  }
  .document-form__card--body {
    padding: 8px 8px;
  }
  .document-form__status--received {
    font-size: 0.5rem;
    padding: 3px 0;
  }
  .document-form__status--none {
    font-size: 0.5rem;
    padding: 3px 0;
  }
}
@media only screen and (min-width: 600px) and (max-width: 991px) {
  .document-form__doc-type {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }
  .document-form__description {
    font-size: 0.95rem;
  }
  .document-form__uploaded-image {
    width: 4.5rem;
    height: 4.5rem;
  }
  .document-form__image-container {
    width: 3.5rem;
    height: 3.5rem;
  }
  .document-form__button-container button {
    width: 70%;
    font-size: 1rem;
  }
  .document-form__button-additional button {
    width: 80%;
  }
  .document-form__card--header-title {
    font-size: 1.25rem;
  }
  .document-form__card--header-progress {
    font-size: 0.95rem;
  }
  .document-form__upload-documents--header {
    font-size: 1.3rem;
  }
  .document-form__upload-documents--description {
    font-size: 0.95rem;
  }
}
.final-card {
  display: flex;
  flex-direction: column;
  background: ${c.white};
  min-height: 20rem;
  border-radius: 0.5rem;
  box-shadow: 0 0px 6px rgba(0, 0, 0, 0.1);
  width: 40%;
  justify-content: center;
  margin: 1rem auto;
}
.final-card__input {
  text-align: center;
  padding-bottom: 3rem;
  font-family: "Open Sans";
  color: ${c.darkBlack1};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}
.final-card__input--description {
  width: 100%;
  text-align: center;
  color: ${c.darkBlack1};
  font-size: 1.4rem;
  list-style-position: inside;
}
.final-card__input--failedFileName {
  font-weight: bold;
}
.final-card__content, .final-card__home-title, .final-card__username, .final-card__button {
  display: flex;
  justify-content: center;
}
.final-card__title, .final-card__home-title, .final-card__username {
  font-size: 3rem;
}
.final-card__home-title, .final-card__title {
  font-weight: bold;
}
.final-card__home-title, .final-card__content {
  align-items: center;
}
.final-card__username {
  color: ${c.ruby};
}
.final-card__title {
  color: ${c.darkBlack1};
  font-family: "Gothic A1", sans-serif;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.625rem;
}
.final-card__content {
  margin-top: 3rem;
  flex-direction: column;
  padding: 1rem 1rem;
  height: 100%;
}
.final-card__title {
  display: flex;
  justify-content: center;
  padding: 1rem 0 2rem 0;
  width: 100%;
}
.final-card__title--red {
  color: ${c.darkBlack1};
}
.final-card__item {
  text-align: center;
  color: ${c.greyDark};
  font-size: 1.5rem;
  padding: 0.5rem 0;
}
.final-card__home-title {
  background: ${c.ruby};
  border-radius: 0.75rem 0.75rem 0 0;
  height: 6rem;
  color: ${c.white};
}
.final-card__username {
  align-self: center;
}
.final-card-trustage {
  width: 40%;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .final-card-trustage {
    width: 40%;
  }
}
@media only screen and (max-width: 599px) {
  .final-card {
    width: 100%;
  }
  .final-card-trustage {
    width: 100%;
  }
}
.loader {
  margin-bottom: 200px;
}
.documents {
  display: grid;
  justify-content: center;
}
.documents__document-info {
  margin: 1rem 0;
  background: ${c.white};
  border-radius: 0.5rem;
  box-shadow: 0 0px 6px rgba(0, 0, 0, 0.1);
  max-height: 87vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 8px;
  padding-bottom: 8px;
}
.documents__dropzone {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.75rem;
  margin-top: 20px;
}
.documents__dropzone__area {
  display: flex;
  justify-content: center;
  border: 2px dashed ${c.greyLighter};
  padding: 18px;
  border-radius: 7px;
  width: 75%;
  margin-left: 10px;
  color: ${c.greyMedium};
}
.documents__dropzone button {
  height: 60px;
  width: 60px;
  border-radius: 10px;
  background-color: ${c.ruby};
  margin-right: 12px;
  color: ${c.white};
}
.documents__additional-items {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 20px;
}
.documents__additional-items--dropdown {
  width: 120px;
}
.documentsErrorModal__content {
  position: relative;
  background-color: ${c.white};
  width: 32rem;
  height: auto;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  padding: 24px;
  transform: translate(-50%, -50%);
  border-radius: 4px;
}
.documentsErrorModal__title {
  font-family: "Gothic A1", sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 130%;
  letter-spacing: 0.15px;
  color: ${c.black};
}
.documentsErrorModal__description {
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 1rem;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin-top: 1rem;
  color: ${c.darkBlack1};
}
.documentsErrorModal__ok-button {
  font-family: "Open Sans";
  font-weight: 600;
  font-size: 1rem;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${c.blue};
  margin-top: 1rem;
  display: flex;
  justify-content: end;
  cursor: pointer;
}
.documentsToast {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  min-width: 320px;
  max-width: 480px;
  background-color: ${c.errorRed};
  color: ${c.white};
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: "Open Sans";
  font-size: 0.95rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: slideDownFade 0.3s ease-out;
}
.documentsToast__message {
  margin-right: 1rem;
}
.documentsToast__close {
  cursor: pointer;
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 1;
}
@keyframes slideDownFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media all and (min-device-width: 576px) {
  .documents__document-info {
    margin: 0.75rem 0;
    max-height: 82vh;
    border-radius: 0.75rem;
    padding: 2.7rem 1.5rem;
  }
  .documents__dropzone {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    font-size: 1rem;
    margin-top: 1rem;
  }
  .documents__dropzone__area {
    width: 100%;
    margin-left: 0;
    padding: 1rem;
    font-size: 0.875rem;
    text-align: center;
    word-break: break-word;
  }
  .documents__dropzone button {
    width: 3.25rem;
    height: 3.25rem;
    margin-right: 0;
    align-self: center;
    border-radius: 0.75rem;
  }
  .documents__additional-items {
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }
  .documents__additional-items--dropdown {
    width: 100%;
  }
  .documentsErrorModal__content {
    width: calc(100vw - 2rem);
    max-width: 100%;
    padding: 1rem;
    border-radius: 0.75rem;
  }
  .documentsErrorModal__title {
    font-size: 1rem;
    line-height: 1.4rem;
  }
  .documentsErrorModal__description {
    font-size: 0.9rem;
    line-height: 1.4rem;
    margin-top: 0.75rem;
  }
  .documentsErrorModal__ok-button {
    font-size: 0.9rem;
    margin-top: 0.75rem;
  }
}
@media only screen and (min-width: 600px) and (max-width: 991px) {
  .documents__document-info {
    max-height: 85vh;
  }
  .documents__dropzone {
    font-size: 1.25rem;
  }
  .documents__dropzone__area {
    width: 80%;
    font-size: 1rem;
    padding: 1rem;
  }
  .documents__dropzone button {
    width: 3.5rem;
    height: 3.5rem;
  }
  .documents__additional-items {
    gap: 1rem;
  }
  .documents__additional-items--dropdown {
    width: 10rem;
  }
  .documentsErrorModal__content {
    width: 28rem;
    max-width: calc(100vw - 3rem);
  }
  .documentsErrorModal__title {
    font-size: 1.1rem;
  }
  .documentsErrorModal__description {
    font-size: 0.95rem;
  }
  .documentsToast {
    min-width: 280px;
    max-width: 420px;
    font-size: 0.9rem;
  }
}
.final {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.final__progress-text {
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 2rem;
}
.final__button-container {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  width: 100%;
}
.final__button-container button {
  width: 35%;
  height: 3.5rem;
  align-items: center;
  border: none;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2509803922);
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  border-radius: 100px;
  letter-spacing: 0.46px;
  font-size: 1.1rem;
  padding: 0.5rem 2rem;
  background-color: ${c.green};
  color: ${c.white};
  font-family: "Open Sans";
}
.final__button-container button:hover {
  background-color: ${c.green} !important;
}
@media only screen and (max-width: 599px) {
  .final {
    width: 100vw;
  }
  .final__loading {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .final__button-container button {
    width: 100%;
    height: 2.5rem;
    font-size: 0.6rem;
  }
  .final__progress-text {
    font-size: 0.8rem;
  }
}
.insurance-offer__powered-by {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  border-bottom: 0.1rem solid ${c.greyLighter};
}
.insurance-offer__powered-by_trustage {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  border-bottom: 0.1rem solid ${c.greyLighter};
}
.insurance-offer__powered-by-text {
  font-family: "Open Sans";
  color: ${c.darkBlack1};
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5rem;
  text-align: left;
}
.insurance-offer__logo {
  height: 100px;
}
.insurance-offer__content {
  display: flex;
  flex-direction: column;
}
.insurance-offer__title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  color: ${c.darkBlack1};
  font-family: "Gothic A1", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5rem;
}
.insurance-offer__subtitle {
  font-family: "Open Sans";
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
  text-align: left;
  margin-bottom: 1rem;
}
.insurance-offer__checkbox {
  margin-right: 1rem;
  transform: scale(1.7);
  padding: 10px;
}
.insurance-offer__get-my-price-button {
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
.insurance-offer__get-my-price-button button {
  width: fit-content;
  height: 3.5rem;
  align-items: center;
  border: none;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2509803922);
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  border-radius: 100px;
  letter-spacing: 0.46px;
  font-size: 1.1rem;
  padding: 0.5rem 2rem;
  background-color: ${c.green};
  color: ${c.white};
  font-family: "Open Sans";
}
.insurance-offer__get-my-price-button button:hover {
  background-color: ${c.green} !important;
}
@media only screen and (max-width: 599px) {
  .insurance-offer__powered-by {
    padding: 0.5rem;
    text-align: center;
  }
  .insurance-offer__powered-by-text {
    font-size: 0.8rem;
    line-height: 1rem;
    text-align: center;
  }
  .insurance-offer__logo {
    height: 3rem;
    max-width: 100%;
    object-fit: contain;
  }
  .insurance-offer__content {
    padding: 0 0.75rem;
  }
  .insurance-offer__title {
    font-size: 0.8rem;
    line-height: 0.9rem;
    text-align: center;
    padding-left: 0;
    height: auto;
    min-height: 2.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .insurance-offer__subtitle {
    font-size: 0.6rem;
    line-height: 0.8rem;
    margin-bottom: 0.5rem;
    text-align: left;
  }
  .insurance-offer__checkbox {
    margin-right: 0.5rem;
    transform: scale(1.2);
    padding: 0.25rem;
  }
  .insurance-offer__get-my-price-button {
    padding: 0 0.3rem;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .insurance-offer__get-my-price-button button {
    width: 100%;
    height: 2rem;
    font-size: 0.6rem;
    padding: 0.5rem 1rem;
    text-align: center;
  }
}
@media only screen and (min-width: 600px) and (max-width: 991px) {
  .insurance-offer__powered-by-text {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }
  .insurance-offer__logo {
    height: 5rem;
    object-fit: contain;
  }
  .insurance-offer__content {
    padding: 0 1rem;
  }
  .insurance-offer__title {
    font-size: 1.3rem;
    line-height: 1.5rem;
    height: auto;
    min-height: 4rem;
  }
  .insurance-offer__subtitle {
    font-size: 1.05rem;
    line-height: 1.6rem;
  }
  .insurance-offer__checkbox {
    transform: scale(1.4);
    margin-right: 0.9rem;
  }
  .insurance-offer__get-my-price-button button {
    font-size: 1rem;
    height: 3.25rem;
    padding: 0.5rem 1.5rem;
  }
}
.referenceSection {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: 1rem;
  height: 4.563rem;
  left: 323px;
  top: 1962px;
  border-bottom: 1px solid ${c.greyLight};
}
.referenceSection .referenceHeading {
  width: 21.875rem;
  height: 20px;
  left: 323px;
  top: 1970px;
  font-style: normal;
  line-height: 20px;
  padding: 1.5rem 0;
  display: inline-block;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 1.15rem;
  font-family: "Helvetica Neue", sans-serif;
  color: ${c.greyDark};
}
.referenceSection__image-container {
  display: flex;
  margin-top: 1rem;
}
.referenceSection__add-edit-icon {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
}
.referenceSection__image-container-edit {
  display: flex;
  margin-top: 1rem;
  margin-right: 1rem;
}
.referenceSection .addbuttondiv {
  float: right;
  margin-right: 2rem;
}
.modal-size {
  position: relative;
  background: ${c.white};
  width: 30rem;
  max-width: calc(100vw - 2rem);
  height: auto;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  box-sizing: border-box;
}
@media (max-width: 480px) {
  .modal-size {
    width: 100%;
    max-width: 100vw;
    border-radius: 0;
    top: 0;
    transform: translate(-50%, 0);
    overflow-y: auto;
    max-height: 100vh;
  }
}
.modal-size .addReferenceContainer {
  display: grid;
  gap: 12px;
  padding: 16px 20px;
}
.modal-size .addReferenceContainer:focus-visible {
  border: none;
  outline: none;
}
.modal-size .textbox {
  width: 100%;
  padding: 15px 8px 7px 12px;
  height: 4rem;
  font-size: 1rem;
  box-sizing: border-box;
  color: ${c.black};
  font-family: "Open Sans";
  font-weight: 400;
  line-height: 1.5rem;
  background-color: ${c.grey3};
  border: 1px solid ${c.grey3};
  border-bottom: 1px solid ${c.grey4};
  border-radius: 4px 4px 0px 0px;
  outline: none;
}
.modal-size .cancel {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 700;
  transition: background-color 0.2s ease;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
  box-shadow: none;
  color: ${c.blue};
  font-family: "Open Sans";
}
.modal-size .save {
  width: 100%;
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-items: center;
  border: none;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2509803922);
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  border-radius: 100px;
  letter-spacing: 0.46px;
  font-size: 1.1rem;
  padding: 0.5rem 2rem;
  background-color: ${c.green};
  color: ${c.white};
  font-family: "Open Sans";
}
.modal-size input[type=button]:disabled {
  background-color: ${c.greyMedium};
  color: ${c.white};
  cursor: not-allowed;
}
.modal-size .w3-button.w3-display-topright {
  display: none;
}
.modal-size .dropdown {
  width: 100%;
  padding: 15px 8px 7px 9px;
  height: 4rem;
  font-size: 1rem;
  box-sizing: border-box;
  color: ${c.greyDark};
  font-family: "Open Sans";
  font-weight: 400;
  line-height: 1.5rem;
  background-color: ${c.grey3};
  border: 1px solid ${c.grey3};
  border-bottom: 1px solid ${c.grey4};
  border-radius: 4px 4px 0px 0px;
  outline: none;
}
.modal-size .input-group {
  position: relative;
}
.modal-size .input-group .textbox {
  width: 100%;
  padding: 15px 8px 7px 12px;
  height: 4rem;
  font-size: 1rem;
  box-sizing: border-box;
  color: ${c.black};
  font-family: "Open Sans";
  font-weight: 400;
  line-height: 1.5rem;
  background-color: ${c.grey3};
  border: 1px solid ${c.grey3};
  border-bottom: 1px solid ${c.grey4};
  border-radius: 4px 4px 0px 0px;
  outline: none;
}
.modal-size .input-group::after {
  content: "*";
  position: absolute;
  top: 6px;
  right: 8px;
  color: ${c.greyDark1};
}
@media only screen and (max-width: 599px) {
  .referenceSection {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    height: auto;
    min-height: 4rem;
    display: flex;
  }
  .referenceSection .referenceHeading {
    width: 100%;
    height: auto;
    padding: 1rem 0;
    font-size: 0.6rem;
    font-weight: 600;
    line-height: 1rem;
    word-break: break-word;
  }
  .referenceSection__image-container, .referenceSection__image-container-edit {
    margin-top: 0px;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .referenceSection__image-container-edit {
    margin-right: 0;
  }
  .referenceSection__add-edit-icon {
    width: 1.25rem;
    height: 1.25rem;
  }
  .referenceSection .addbuttondiv {
    float: none;
    margin-right: 0;
    margin-top: 0.75rem;
    display: flex;
    justify-content: flex-end;
  }
  .modal-size {
    width: 100%;
    max-width: 100vw;
    border-radius: 0;
    top: 0;
    transform: translate(-50%, 0);
    overflow-y: auto;
    max-height: 100vh;
  }
  .modal-size .addReferenceContainer {
    padding: 1rem;
    gap: 0.75rem;
  }
  .modal-size .textbox,
  .modal-size .dropdown,
  .modal-size .input-group .textbox {
    height: 2.5rem;
    font-size: 0.6rem;
    line-height: 0.8rem;
    padding: 0.75rem 0.75rem 0.5rem 0.75rem;
  }
  .modal-size .save {
    height: 2rem;
    font-size: 0.7rem;
    padding: 0.5rem 1rem;
    width: 100%;
  }
  .modal-size .cancel {
    font-size: 0.7rem;
    padding: 0.5rem;
  }
  .modal-size .input-group::after {
    top: 5px;
    right: 6px;
    font-size: 0.7rem;
  }
}
@media only screen and (min-width: 600px) and (max-width: 991px) {
  .referenceSection {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .referenceSection .referenceHeading {
    width: 100%;
    font-size: 1.05rem;
    line-height: 1.5rem;
  }
  .referenceSection__image-container, .referenceSection__image-container-edit {
    gap: 0.75rem;
    flex-wrap: wrap;
  }
  .referenceSection__add-edit-icon {
    width: 1.4rem;
    height: 1.4rem;
  }
  .referenceSection .addbuttondiv {
    margin-right: 1rem;
  }
  .modal-size {
    width: 28rem;
    max-width: calc(100vw - 2rem);
  }
  .modal-size .addReferenceContainer {
    padding: 1rem 1.25rem;
  }
  .modal-size .textbox,
  .modal-size .dropdown,
  .modal-size .input-group .textbox {
    font-size: 1rem;
    height: 3.75rem;
  }
  .modal-size .save {
    font-size: 1rem;
    height: 3.25rem;
  }
  .modal-size .cancel {
    font-size: 0.9rem;
  }
}
`;
};
